import Api from "../../../services/api";

export function loadCboGroupEmployee(params, cb) {
    return () => {
        Api.put('/W17F3115/load-dropdown-group', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadCboEmployee(params, cb) {
    return () => {
        Api.put('/W17F3115/load-dropdown-employee', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}

export function loadForm(params, cb) {
    return () => {
        Api.put('/W17F3115/load-form', params)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                }
            });
    };
}